export class Listing {
    has_category_exhibitor: boolean = false;
    has_category_organizer: boolean = false;
    has_category_speaker: boolean = false;
    has_category_sponsor: boolean = false;
    has_category_track: boolean = false;
    has_category_type: boolean = false;

    hasSessionHalls: boolean = true;
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/listing.ts